import React, { createContext } from 'react';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut as firebaseSignOut,
  onAuthStateChanged
} from 'firebase/auth';
import { auth } from '../utils/firebase';

const AccountContext = createContext();

const Account = props => {

  /**
   * Gets a User's Session
   * Resolves if logged in, rejects if not
   * @returns {Promise<unknown>}
   */
  const getSession = async () =>
    await new Promise((resolve, reject) => {
      // onAuthStateChanged returns an unsubscribe function
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe(); // Unsubscribe immediately after first call
        if (user) {
          // User is logged in
          resolve({
            user,
            accessToken: user.accessToken,
            idToken: user.getIdToken()
          });
        } else {
          // No user logged in
          reject(new Error('No user logged in'));
        }
      });
    });

  /**
   * Authenticate user with email and password
   * @param {string} email - User's email
   * @param {string} password - User's password
   * @returns {Promise<UserCredential>}
   */
  const authenticate = async (email, password) =>
    await new Promise(async (resolve, reject) => {
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        console.log('onSuccess:', userCredential);
        resolve(userCredential);
      } catch (error) {
        console.error('onFailure:', error);
        reject(error);
      }
    });

  /**
   * Logout current user
   */
  const logout = async () => {
    console.log("in logout!");
    try {
      await firebaseSignOut(auth);
      console.log('User signed out successfully');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const goto = () => {
    console.log("in goto!");
  };

  /**
   * Register a new user with email and password
   * @param {string} email - User's email
   * @param {string} password - User's password
   * @returns {Promise<UserCredential>}
   */
  const register = async (email, password) => {
    console.log(`Accounts.js => Account.register(${email},${password})`);
    console.log('Auth object:', auth);
    console.log('createUserWithEmailAndPassword function:', createUserWithEmailAndPassword);

    if (!auth) {
      console.error('AUTH IS NULL OR UNDEFINED!');
      throw new Error('Firebase auth is not initialized');
    }

    try {
      console.log('About to call createUserWithEmailAndPassword...');
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      console.log('User registered successfully:', userCredential);
      return userCredential;
    } catch (error) {
      console.error('Registration error:', error);
      console.error('Error type:', typeof error);
      console.error('Error object:', JSON.stringify(error, null, 2));
      throw error;
    }
  };

  return (
    <AccountContext.Provider value={{
      authenticate,
      getSession,
      logout,
      goto,
      register,
    }}>
      {props.children}
    </AccountContext.Provider>
  );
};

export { Account, AccountContext };
